// import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useTasks } from "../Tasks";
import Empty from "./Empty";
import Task from "./Task";

const TomorrowTaskList = () => {
  const { tomorrowsTasks } = useTasks();
  const titleString = "Tomorrow";

  return (
    <section id={titleString}>
      <h2 className="task-list-title">{titleString}</h2>
      {/* <TransitionGroup className="transition-group"> */}
      {tomorrowsTasks.map((task) => (
        // <CSSTransition timeout={500} classNames="fade" key={task.id}>
        <Task
          id={task.id}
          text={task.text}
          complete={task.complete}
          created={task.created}
          pushed={task.pushed}
        />
        // </CSSTransition>
      ))}
      {/* </TransitionGroup> */}
      <Empty today={false}></Empty>
    </section>
  );
};

export default TomorrowTaskList;
